export default "__VITE_ASSET__cd7430d1__"